<ng-container *ngIf="agent">
	<div class="row">
		<div class="col mb-3 h3">
			Agent View:
			<nz-icon nzType="clock-circle" nzTheme="fill" [ngClass]="{'text-secondary': agent.online == undefined, 'text-success': agent.online == true, 'text-danger': agent.online == false}"/>
			{{agent.firstName}} {{agent.lastName}}
		</div>
		<ng-container *ngIf="isSelf">
			<div class="col text-end" *hasPermission="['AgentSelfEdit']" >
				<button type="button" class="btn btn-primary me-1" (click)="doEdit()">Edit</button>
			</div>
		</ng-container>
		<div class="col text-end" *ngIf="!isSelf">
			<div class="btn-group">
				<button type="button" class="btn btn-primary me-1" *hasPermission="['AgentOtherEdit']" (click)="doEdit()">Edit</button>
				<ng-container *ngIf="agent.status == 'PendingApproval'">
					<button type="button" class="btn btn-primary me-1" *hasPermission="['AgentAccountApproval']" [routerLink]="['/agent','approval',agent.id]">Goto Approval</button>
				</ng-container>
				<ng-container *ngIf="agent.status == 'Approved' || agent.status == 'BlockedOtp'">
					<button type="button" class="btn btn-danger me-1" *hasPermission="['AgentBlock']" (click)="doBlock()">Block</button>
				</ng-container>
				<ng-container *ngIf="agent.status == 'Blocked'">
					<button type="button" class="btn btn-primary me-1" *hasPermission="['AgentUnblock']" (click)="doUnblock()">Unblock</button>
				</ng-container>
				<ng-container *ngIf="agent.status == 'BlockedOtp' || agent.status == 'Rejected'">
					<button type="button" class="btn btn-primary" *hasPermission="['AgentReset']" (click)="doReset()">Reset</button>
				</ng-container>
			</div>
		</div>
	</div>
</ng-container>

<nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small" *ngIf="agent" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="setSelectedTab($event)">
	<nz-tab [nzTitle]="'Agent View'" class="m-0">
		<div class="row mb-3">
			<div class="col">
				<div class="card" [ngClass]="getCardBorderColor()">
					<div class="card-header" [ngClass]="getCardHeaderColor()">Portrait</div>
					<div class="card-body m-auto" *ngIf="agent.portraitImage">
						<img [src]="portraitImageUrl" style="max-height: 15em; max-width: 100%;"/>
					</div>
					<div class="card-body m-auto" *ngIf="!agent.portraitImage">
						<nz-empty nzNotFoundImage="simple"></nz-empty>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card" [ngClass]="getCardBorderColor()">
					<div class="card-header" [ngClass]="getCardHeaderColor()">Document Front</div>
					<div class="card-body m-auto" *ngIf="agent.documentFrontImage">
						<img [src]="documentFrontImageUrl" style="max-height: 15em; max-width: 100%;"/>
					</div>
					<div class="card-body m-auto" *ngIf="!agent.documentFrontImage">
						<nz-empty nzNotFoundImage="simple"></nz-empty>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card" [ngClass]="getCardBorderColor()">
					<div class="card-header" [ngClass]="getCardHeaderColor()">Document Back</div>
					<div class="card-body m-auto" *ngIf="agent.documentBackImage">
						<img [src]="documentBackImageUrl" style="max-height: 15em; max-width: 100%;"/>
					</div>
					<div class="card-body m-auto" *ngIf="!agent.documentBackImage">
						<nz-empty nzNotFoundImage="simple"></nz-empty>
					</div>
				</div>
			</div>
			<div class="col" *ngIf="agent.governmentPhotoImage">
				<div class="card" [ngClass]="getCardBorderColor()">
					<div class="card-header" [ngClass]="getCardHeaderColor()">Government Photo</div>
					<div class="card-body m-auto" *ngIf="agent.governmentPhotoImage">
						<img [src]="governmentPhotoImageUrl" style="max-height: 15em; max-width: 100%;"/>
					</div>
					<div class="card-body m-auto" *ngIf="!agent.governmentPhotoImage">
						<nz-empty nzNotFoundImage="simple"></nz-empty>
					</div>
				</div>
			</div>
			<div class="col" *ngIf="agent.governmentPassportImage">
				<div class="card" [ngClass]="getCardBorderColor()">
					<div class="card-header" [ngClass]="getCardHeaderColor()">Government Passport</div>
					<div class="card-body m-auto" *ngIf="agent.governmentPassportImage">
						<img [src]="governmentPassportImageUrl" style="max-height: 15em; max-width: 100%;"/>
					</div>
					<div class="card-body m-auto" *ngIf="!agent.governmentPassportImage">
						<nz-empty nzNotFoundImage="simple"></nz-empty>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="row mb-1">
					<div class="col">
						<div class="card" [ngClass]="getCardBorderColor()">
							<div class="card-header" [ngClass]="getCardHeaderColor()">Agent Details</div>
							<div class="card-body">
								<table class="table table-sm table-borderless">
									<tbody>
										<tr>
											<td>Phone Number</td>
											<td *ngIf="!agent.pendingMsisdn">{{agent.msisdn}}</td>
											<td *ngIf="agent.pendingMsisdn" class="text-danger" style="text-decoration: line-through;">
												<small>{{agent.msisdn}}</small>
											</td>
										</tr>
										<tr *ngIf="agent.pendingMsisdn">
											<td class="text-secondary float-end">Pending</td>
											<td class="text-success">{{agent.pendingMsisdn}}</td>
										</tr>

										<tr>
											<td>Email Address</td>
											<td *ngIf="!agent.pendingEmailAddress">{{agent.emailAddress}}</td>
											<td *ngIf="agent.pendingEmailAddress" class="text-danger" style="text-decoration: line-through;">
												<small>{{agent.emailAddress}}</small>
											</td>
										</tr>
										<tr *ngIf="agent.pendingEmailAddress">
											<td class="text-secondary float-end">Pending</td>
											<td class="text-success">{{agent.pendingEmailAddress}}</td>
										</tr>
										<tr><td>Created At</td><td>{{agent.createdAt | date}}</td></tr>
										<tr><td>Status</td><td>{{agent.status}}</td></tr>
										<tr><td>Partner</td><td>{{agent.partner!.name}}</td></tr>
										<tr><td>Username</td><td>{{agent.username}}</td></tr>
										<tr><td>ID Type</td><td>{{agent.idType}}</td></tr>
										<tr><td>ID Number</td><td>{{agent.idNumber}}</td></tr>
										<tr><td>First Name</td><td>{{agent.firstName}}</td></tr>
										<tr><td>Second Name</td><td>{{agent.secondName}}</td></tr>
										<tr><td>Other Names</td><td>{{agent.otherNames}}</td></tr>
										<tr><td>Last Name</td><td>{{agent.lastName}}</td></tr>
										<tr><td>Date Of Birth</td><td>{{agent.dateOfBirth | date}}</td></tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="row mb-3">
					<div class="col">
						<div class="card" [ngClass]="getCardBorderColor()">
							<div class="card-header" [ngClass]="getCardHeaderColor()">Provisioned By</div>
							<div class="card-body">
								<table class="table table-sm table-borderless">
									<thead>
										<tr>
											<th>Agent ID</th>
											<th>Agent Name</th>
											<th>Partner</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>{{agent.provisioningAgent?.id}}</td>
											<td>
												{{agent.provisioningAgent?.firstName}} {{agent.provisioningAgent?.secondName}} {{agent.provisioningAgent?.otherNames}} {{agent.provisioningAgent?.lastName}}</td>
											<td>{{agent.provisioningAgent?.partner?.name}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="card" [ngClass]="getCardBorderColor()">
							<div class="card-header" [ngClass]="getCardHeaderColor()">Approval</div>
							<div class="card-body" *ngIf="agent.approvals!.length > 0">
								<table class="table table-sm table-borderless">
									<thead>
										<tr>
											<th>When</th>
											<th>Who</th>
											<th>Status</th>
											<th>Reason</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let approval of agent.approvals">
											<td>{{approval.createdAt | date}}</td>
											<td>{{approval.approvalAgent?.username}}</td>
											<td>{{approval.status}}</td>
											<td>{{approval.reason}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="card-body m-auto" *ngIf="agent.approvals!.length == 0">
								<nz-empty nzNotFoundImage="simple"></nz-empty>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col">
				<div class="card" [ngClass]="getCardBorderColor()">
					<div class="card-header" [ngClass]="getCardHeaderColor()">Government Details</div>
					<div class="card-body" *ngIf="agent.governmentRecord">
						<table class="table table-sm table-borderless" *ngIf="agent.governmentRecord">
							<tbody>
								<tr><td>Loaded At</td><td>{{agent.governmentRecord!.createdAt | date}}</td></tr>
								<tr><td>Document Type</td><td>{{agent.governmentRecord!.documentType}}</td></tr>
								<tr><td>Document Number</td><td>{{agent.governmentRecord!.documentNumber}}</td></tr>
								<tr><td>ID Number</td><td>{{agent.governmentRecord!.idNumber}}</td></tr>
								<tr><td>First Name</td><td>{{agent.governmentRecord!.firstName}}</td></tr>
								<tr><td>Other Names</td><td>{{agent.governmentRecord!.otherName}}</td></tr>
								<tr><td>Last Name</td><td>{{agent.governmentRecord!.surname}}</td></tr>
								<tr><td>Family</td><td>{{agent.governmentRecord!.family}}</td></tr>
								<tr><td>Gender</td><td>{{agent.governmentRecord!.gender}}</td></tr>
								<tr><td>Date of Birth</td><td>{{agent.governmentRecord!.dateOfBirth | date}}</td></tr>
								<tr><td>Date of Issue</td><td>{{agent.governmentRecord!.dateOfIssue | date}}</td></tr>
								<tr><td>Date of Expiry</td><td>{{agent.governmentRecord!.dateOfExpiry | date}}</td></tr>
								<tr><td>Date of Death</td><td>{{agent.governmentRecord!.dateOfDeath | date}}</td></tr>
								<tr><td>Citizenship</td><td>{{agent.governmentRecord!.citizenship}}</td></tr>
								<tr><td>Clan</td><td>{{agent.governmentRecord!.clan}}</td></tr>
								<tr><td>Ethnic Group</td><td>{{agent.governmentRecord!.ethnicGroup}}</td></tr>
								<tr><td>Occupation</td><td>{{agent.governmentRecord!.occupation}}</td></tr>
								<tr><td>Place Of Birth</td><td>{{agent.governmentRecord!.placeOfBirth}}</td></tr>
								<tr><td>Place Of Death</td><td>{{agent.governmentRecord!.placeOfDeath}}</td></tr>
								<tr><td>Place Of Live</td><td>{{agent.governmentRecord!.placeOfLive}}</td></tr>
								<tr><td>Reg Office</td><td>{{agent.governmentRecord!.regOffice}}</td></tr>

							</tbody>
						</table>
					</div>
					<div class="card-body m-auto" *ngIf="!agent.governmentRecord">
						<nz-empty nzNotFoundImage="simple"></nz-empty>
					</div>
				</div>
			</div>
		</div>
	</nz-tab>
	<nz-tab [nzTitle]="'Permissions'" class="m-0">
		<app-agent-permissions [agent]="agent"></app-agent-permissions>
	</nz-tab>
	<nz-tab [nzTitle]="'Audit: Sessions'" class="m-0" *hasPermission="['AuditSessionList']">
		<app-agent-audit-sessions *ngIf="isRender('AuditSessionList')" [agent]="agent"></app-agent-audit-sessions>
	</nz-tab>
	<nz-tab [nzTitle]="'Audit: Views'" class="m-0" *hasPermission="['AuditViewList']">
		<app-agent-audit-views  *ngIf="isRender('AuditViewList')" [agent]="agent"></app-agent-audit-views>
	</nz-tab>
	<nz-tab [nzTitle]="'Audit: Searched'" class="m-0" *hasPermission="['AuditSearchList']">
		<app-agent-audit-searches  *ngIf="isRender('AuditSearchList')" [agent]="agent"></app-agent-audit-searches>
	</nz-tab>
	<nz-tab [nzTitle]="'Change history'" class="m-0" *hasPermission="['AuditModificationList']">
		<app-agent-audit-modifications  *ngIf="isRender('AuditModificationList')"  [agent]="agent"></app-agent-audit-modifications>
	</nz-tab>
</nz-tabset>
